/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tb_Prd_TitleInputs */

const en_mk_tb_prd_title = /** @type {(inputs: Mk_Tb_Prd_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bring a PRD`)
};

const id_mk_tb_prd_title = /** @type {(inputs: Mk_Tb_Prd_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bawa PRD Anda`)
};

/**
* | output |
* | --- |
* | "Bring a PRD" |
*
* @param {Mk_Tb_Prd_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tb_prd_title = /** @type {((inputs?: Mk_Tb_Prd_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tb_Prd_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tb_prd_title(inputs)
	return en_mk_tb_prd_title(inputs)
});